import React, { useState, useEffect } from "react";
import { Chart } from "primereact/chart";
import { SelectButton } from "primereact/selectbutton";
import { Accordion, AccordionTab } from 'primereact/accordion';
import useFetchData from "hooks/useFetchDataWithDep";

import { getData } from "helper/getData";
import TripsFilters from "../TripsFilters";
import DateRangeFilter from "../DateRangeFilter";

const RecipesChart = () => {
    const [selectedDrivers, setSelectedDrivers] = useState(null);
    const [selectedTaxis, setSelectedTaxis] = useState(null);
    const [dateBegin, setDateBegin] = useState(null);
    const [dateEnd, setDateEnd] = useState(null);
    const [aggregation, setAggregation] = useState('day');
    const [urlParams, setUrlParams] = useState('');
    const [activeIndex, setActiveIndex] = useState(0);
  
    const aggregationOptions = [
      { label: 'Jour', value: 'day' },
      { label: 'Mois', value: 'month' },
      { label: 'Année', value: 'year' }
    ];

    useEffect(() => {
      let params = [];
      if (aggregation !== 'day') {
        params.push(`aggregate=${aggregation}`);
      }
      if (selectedDrivers?.length === 1) {
        params.push(`driver=${selectedDrivers[0].code}`);
      }
      if (selectedTaxis?.length === 1) {
        params.push(`taxi=${selectedTaxis[0].code}`);
      }
      if (dateBegin) {
        params.push(`date_begin=${dateBegin}`);
      }
      if (dateEnd) {
        params.push(`date_end=${dateEnd}`);
      }
      
      const newUrlParams = params.length > 0 ? `?${params.join('&')}` : '';
      setUrlParams(newUrlParams);
    }, [aggregation, selectedDrivers, selectedTaxis, dateBegin, dateEnd]);
  
    const url = `/front/histogramstats/recipes${urlParams}`;
    const { data, isLoading } = useFetchData(url, null, urlParams);
  
    
  
    const apiData = getData(data);
  
    const chartData = {
      labels: apiData?.labels || [],
      datasets: [
        {
          label: 'Montant des recettes',
          data: apiData?.datasets?.[0]?.data || [],
          backgroundColor: apiData?.datasets?.[0]?.backgroundColor || [],
          borderColor: apiData?.datasets?.[0]?.borderColor || [],
          borderWidth: apiData?.datasets?.[0]?.borderWidth || 1
        }
      ]
    };
  
    const options = {
      maintainAspectRatio: false,
      aspectRatio: 0.8,
      plugins: {
        legend: {
          position: 'top'
        },
        title: {
          display: true,
          text: 'Statistiques des Recettes'
        }
      },
      scales: {
        y: {
          beginAtZero: true,
          title: {
            display: true,
            text: 'Montant (CHF)'
          }
        },
        x: {
          title: {
            display: true,
            text: aggregation === 'year' ? 'Année' : aggregation === 'month' ? 'Mois' : 'Date'
          }
        }
      }
    };

    const chartContent = (
        <div>
            <div className="flex flex-column gap-2">
                <div className="flex justify-content-between align-items-center">
                    <TripsFilters
                        selectedDrivers={selectedDrivers}
                        setSelectedDrivers={setSelectedDrivers}
                        selectedTaxis={selectedTaxis}
                        setSelectedTaxis={setSelectedTaxis}
                    />
                    <SelectButton 
                        value={aggregation} 
                        onChange={(e) => setAggregation(e.value)} 
                        options={aggregationOptions} 
                        className="p-buttonset-sm"
                        pt={{
                            button: ({ context }) => ({
                                style: {
                                  backgroundColor: context.selected ? '#ffdc45' : '#FFE87C',
                                  color: 'black',
                                  border: 'none',
                                  fontWeight: context.selected ? 'bold' : 'normal',
                                  transition: 'all 0.2s'
                                }
                            })
                        }}
                    />
                </div>
                <DateRangeFilter
                    dateBegin={dateBegin}
                    setDateBegin={setDateBegin}
                    dateEnd={dateEnd}
                    setDateEnd={setDateEnd}
                /> 
            </div>
            <div style={{ height: '400px', width: '100%', marginTop: '1rem' }}>
                <Chart type="bar" data={chartData} options={options} />
            </div>
        </div>
    );

    return (
        <div className="pt-4">
            <Accordion activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                <AccordionTab header={<span style={{ color: '#000000' }}>Statistiques des recettes</span>}>
                    {chartContent}
                </AccordionTab>
            </Accordion>
        </div>
    );
};

export default RecipesChart; 